export default function NextStpeIco({ size }) {
  return (
    <svg
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#DBFAE6" />
      <path
        d="M12.0003 8.66663C10.1594 8.66663 8.66699 10.159 8.66699 12C8.66699 12.9075 9.02967 13.7303 9.618 14.3314C9.84716 14.5656 10.0355 14.8442 10.0998 15.1654L10.4525 16.9282C10.5772 17.5514 11.1245 18 11.76 18H12.2407C12.8762 18 13.4234 17.5514 13.5481 16.9282L13.9009 15.1654C13.9651 14.8442 14.1535 14.5656 14.3827 14.3314C14.971 13.7303 15.3337 12.9075 15.3337 12C15.3337 10.159 13.8413 8.66663 12.0003 8.66663Z"
        stroke="#079455"
        stroke-width="1.6"
      />
      <path
        d="M12 6.66667V6"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 8.00004L16.6667 7.33337"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.333 12H17.9997"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 12H6"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33301 7.33337L7.99967 8.00004"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.667 15.3334H13.3337"
        stroke="#079455"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
